import React, { useState } from "react";
import { useDropzone } from "react-dropzone";
import axios from "axios";

export const AddAudio = () => {
    const [videoFile, setVideoFile] = useState(null);
    const [audioFile, setAudioFile] = useState(null);
    const [resultFile, setResultFile] = useState(null);

    const onDropVideo = (acceptedFiles) => {
        if (acceptedFiles.length > 0) {
            setVideoFile(acceptedFiles[0]);
            
            
        }
    };

    const onDropAudio = (acceptedFiles) => {
        if (acceptedFiles.length > 0) {
            setAudioFile(acceptedFiles[0]);
            
        }
    };

    const handleMerge = async () => {
        if (!videoFile || !audioFile) {
            alert("Please upload both video and audio files.");
            return;
        }

        const formData = new FormData();
        formData.append("video", videoFile); // Name matches "video" in backend
        formData.append("audio", audioFile); // Name matches "audio" in backend
    
        try {
            
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/merge-audio`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
                responseType: 'blob',
            });
            setResultFile(response.data.fileUrl);
            
            
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `edited_video_${Date.now()}.mp4`);
            document.body.appendChild(link);
            link.click();
            link.remove();


        } catch (error) {
            console.error("Error merging files:", error);
        }
    };

    return (
        <div>
            <h1 style={{ textAlign: "center", padding: "20px" }}>Video Editing Tool - Add Audio</h1>
            <div>
                <h3>Upload Video</h3>
                <div
                    style={{
                        border: "2px dashed #cccccc",
                        padding: "20px",
                        margin: "10px 0",
                    }}
                >
                    <Dropzone onDrop={onDropVideo} accept="video/*" />
                </div>
                {videoFile && <p>Selected Video: {videoFile.name}</p>}
            </div>
            <div>
                <h3>Upload Audio</h3>
                <div
                    style={{
                        border: "2px dashed #cccccc",
                        padding: "20px",
                        margin: "10px 0",
                    }}
                >
                    <Dropzone onDrop={onDropAudio} accept="audio/*" />
                </div>
                {audioFile && <p>Selected Audio: {audioFile.name}</p>}
            </div>
            <button onClick={handleMerge}>Merge Audio with Video</button>
            {resultFile && (
                <div>
                    <h3>Result:</h3>
                    <video controls src={resultFile} width="600"></video>
                </div>
            )}
        </div>
    );
};

const Dropzone = ({ onDrop, accept }) => {
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept,
    });

    return (
        <div
            {...getRootProps()}
            style={{
                border: "2px dashed #999",
                padding: "20px",
                cursor: "pointer",
            }}
        >
            <input {...getInputProps()} />
            {isDragActive ? (
                <p>Drop the files here...</p>
            ) : (
                <p>Drag and drop files here, or click to select files</p>
            )}
        </div>
    );
}
